import { NoResultsRoot } from 'src/common/components/ConfigurableTable/Components/NoRowsOverlay';
import { useTariffAccountRef } from '../../hooks/useTariffAccountRef';
import { useTranslation } from 'react-i18next';
import Typography from "@mui/material/Typography";
import NotFoundSmall from 'assets/images/notFoundSmall.png';

export const TariffSummaryNoRows = () => {
  const { t } = useTranslation();
  const accountRef = useTariffAccountRef();

  return (
    <NoResultsRoot>
      <img src={NotFoundSmall} alt="" />
      <Typography variant="h3" color="text.secondary">
        {accountRef ? t('common.noResults') : t('tariffSummary.table.selectAccount')}
      </Typography>
    </NoResultsRoot>
  );
};
